export const DATE_LAST_UPDATE = "2022-05-23";
